import AdminArticleDetailPage from './AdminArticleDetailPage';

export default AdminArticleDetailPage;
